import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  user: null,
  loading: false,
  success: false,
  error: null,
  updateSuccess: false,
  passwordChangeSuccess: false,
  updateUserProfileViolations: null,
  changePasswordViolations: null
};

const AdminProfileSlice = createSlice({
  name: "AdminProfile",
  initialState,
  reducers: {
    // Pobieranie profilu
    getUserProfileRequest(state) {
      state.loading = true;
      state.error = null;
    },
    getUserProfileSuccess(state, action) {
      state.loading = false;
      state.user = action.payload;
      state.error = null;
    },
    getUserProfileFailed(state, action) {
      state.loading = false;
      state.error = action.payload;
    },

    // Aktualizacja profilu
    updateUserProfileRequest(state) {
      state.loading = true;
      state.updateSuccess = false;
      state.error = null;
      state.updateUserProfileViolations = null;
    },
    updateUserProfileSuccess(state, action) {
      state.loading = false;
      state.updateSuccess = true;
      state.user = action.payload;
      state.error = null;
      state.updateUserProfileViolations = null;
    },
    updateUserProfileFailed(state, action) {
      state.loading = false;
      state.updateSuccess = false;
      state.error = true;
      state.updateUserProfileViolations = action.payload;
    },

    // Zmiana hasła
    changePasswordRequest(state) {
      state.loading = true;
      state.passwordChangeSuccess = false;
      state.error = null;
      state.changePasswordViolations = null
    },
    changePasswordSuccess(state) {
      state.loading = false;
      state.passwordChangeSuccess = true;
      state.error = null;
      state.changePasswordViolations = null;
    },
    changePasswordFailed(state, action) {
      state.loading = false;
      state.passwordChangeSuccess = false;
      state.error = true;
      state.changePasswordViolations = action.payload;
    },

    // Reset
    resetProfileFlags(state) {
      state.updateSuccess = false;
      state.passwordChangeSuccess = false;
      state.error = null;
      state.changePasswordViolations = null;
      state.updateUserProfileViolations = null;
    },
  },
});

export const {
  getUserProfileRequest,
  getUserProfileSuccess,
  getUserProfileFailed,
  updateUserProfileRequest,
  updateUserProfileSuccess,
  updateUserProfileFailed,
  changePasswordRequest,
  changePasswordSuccess,
  changePasswordFailed,
  resetProfileFlags,
} = AdminProfileSlice.actions;

export default AdminProfileSlice.reducer;
